import type { ComponentRef } from '@wix/editor-platform-sdk-types'

type Condition = string

export const filterResolverKey = '@resolver'

export type FilterExpressionBase =
  | StaticValue
  | LoggedInUser
  | UserInputV1
  | Dataset
  | StaticMultiRef

export type FilterExpression = FilterExpressionBase & {
  [filterResolverKey]?: string
}

interface LoggedInUser {
  condition: Condition
  field: '_owner'
}

interface StaticValue {
  condition: Condition
  field: string
  value: string
}

interface UserInputV1 {
  component: ComponentRef
  componentType: string
  componentValueIsArray: boolean
  condition: Condition
  field: string
  filterId: string
}

interface Dataset {
  condition: Condition
  dataset: ComponentRef
  datasetField: string
  datasetFieldIsArray: boolean
  field: string
  filterId: string
}

interface StaticMultiRef {
  condition: Condition
  field: string
  referencedValue: string
  staticMultiRef: boolean
}
